export const MEMBERS_ACTIONS = {
  EDIT_MEMBER: 'edit',
  NEW_MEMBER: 'new',
  VIEW_MEMBER: 'view',
  APPLY_ONBOARDING_TEMPLATE: 'apply-onboarding-template',
};
